import { useDispatch } from "react-redux"
import { useClient } from "../providers/supabase"
import { useAsyncAction } from "./useAsyncAction"
import { useBackendApi } from "./useBackendApi"
import { ProfileModel, setProfile } from "../reduxToolkit/membershipSlice"
import merge from "lodash/merge"
import { useAppSelector } from "./reduxToolkit"
import { selectUsersAndDependentsForMembership } from "../../lib/queries/selectUsersAndDependentsForMembership"
import { onSyncDependents } from "../reduxToolkit/dependentsSlice"
import { updateMyProfile, type ProfileUpdate } from "@healthshare/shared/commands/account"

export function useUpdateProfile() {
  const client = useClient()
  const api = useBackendApi()
  const dispatch = useDispatch()
  const profile = useAppSelector((s) => s.membership.profile)
  const membershipId = useAppSelector((s) => s.membership.membershipId)

  return useAsyncAction(async (unsavedProfile: Partial<ProfileModel>) => {
    // No `id` and no `updated_at`: the endpoint takes the row id from the JWT
    // (so a caller cannot name someone else's profile) and stamps the timestamp
    // itself. See docs/plans/native-app-sdk-seams.md, Stage 2 Step 4.
    const saved = await updateMyProfile(api, unsavedProfile as ProfileUpdate)

    dispatch(setProfile({
      profile: merge({}, profile, saved)
    }))

    // Now that we've created the profile, we need to keep the local dependents list in sync.
    const result = await selectUsersAndDependentsForMembership(client, { membershipId })
    dispatch(onSyncDependents({
      ...result
    }))

    return saved
  }, [api, client, membershipId, profile, dispatch])
}
